const MapStyle = [
    { featureType: "administrative", elementType: "all", stylers: [{ visibility: "on" }, { lightness: 33 }] },
    { featureType: "landscape", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 0 }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: -100 }, { lightness: 0 }] },
    { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "road", elementType: "all", stylers: [{ lightness: 30 }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ saturation: -100 }, { lightness: 0 }] },
    { featureType: "road.arterial", elementType: "geometry", stylers: [{ saturation: -100 }, { lightness: 0 }] },
    { featureType: "road.local", elementType: "geometry", stylers: [{ saturation: -100 }, { lightness: 0 }] },
    { featureType: "water", elementType: "all", stylers: [{ visibility: "on" }, { saturation: -90 }] },
];

let map;
let originMarker;
let infoWindow;
let searchCounter = 0;

function initMap() {
    map = new google.maps.Map(document.getElementById("map"), {
        zoom: 5.75,
        center: { lat: 21.5449763, lng: -98.9680817 },
        styles: MapStyle,
        disableDefaultUI: true,
        gestureHandling: "greedy",
    });

    originMarker = new google.maps.Marker({ map });
    originMarker.setVisible(false);

    infoWindow = new google.maps.InfoWindow();

    map.data.loadGeoJson(storeslink, { idPropertyName: "storeid" });

    // WAIT UNTIL MAP IS READY + DATA LOADED
    google.maps.event.addListenerOnce(map, "idle", () => {
        setTimeout(async () => {
            const initialStores = getInitialStores(map.data);

            // SHOW ALL STORES FIRST
            showStoresList(map.data, initialStores);

            // TRY GEOLOCATION AFTER RENDER
            if (!navigator.geolocation) return;

            navigator.geolocation.getCurrentPosition(
                async (pos) => {
                    const coords = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    };

                    setUserMarker(coords, false);

                    const rankedStores = await calculateDistances(map.data, coords);
                    const closestStoreId = rankedStores[0]?.storeid;

                    searchCounter++;
                    showStoresList(map.data, rankedStores, closestStoreId);
                },
                () => {
                    // user denied → keep initial list
                }
            );
        }, 300);
    });

    // ---------------- MAP EVENTS ----------------

    map.data.addListener("click", (event) => {
        showStoreInformation(event);
    });

    map.data.addListener("mouseover", (event) => {
        map.data.revertStyle();
        map.data.overrideStyle(event.feature, {
            icon: {
                url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pinhover.webp",
                scaledSize: new google.maps.Size(35, 35),
            },
        });
    });

    map.data.addListener("mouseout", () => {
        map.data.revertStyle();
    });

    map.data.setStyle(() => ({
        icon: {
            url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pin.webp",
            scaledSize: new google.maps.Size(35, 35),
        },
    }));

    // ---------------- PANEL CLICK (ONLY ONCE) ----------------

    const panel = document.getElementById("storelistcont");

    panel.addEventListener("click", (event) => {
        const clickedStoreId =
            event.target.closest(".description_cont")?.dataset.storeid;

        if (clickedStoreId) {
            const store = map.data.getFeatureById(clickedStoreId);
            showStoreInformation({ feature: store });

            map.setCenter(store.getGeometry().get("coordinates"));
            map.setZoom(13);
        }
    });

    // ---------------- SEARCH ----------------

    const input = document.getElementById("mapsearchbar");

    const autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: "mx" },
    });

    autocomplete.addListener("place_changed", async () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) return;

        const loc = place.geometry.location;

        setUserMarker(loc, true);

        map.setCenter(loc);
        map.setZoom(13);

        const rankedStores = await calculateDistances(map.data, loc);
        const closestStoreId = rankedStores[0]?.storeid;

        searchCounter++;
        showStoresList(map.data, rankedStores, closestStoreId);
    });

    // ---------------- FIND NEAREST BUTTON ----------------

    document.getElementById("findNearestBtn").addEventListener("click", async () => {
        if (!navigator.geolocation) return alert("Geolocalización no soportada");

        navigator.geolocation.getCurrentPosition(async (pos) => {
            const coords = {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
            };

            setUserMarker(coords, true);

            const rankedStores = await calculateDistances(map.data, coords);
            const closestStoreId = rankedStores[0]?.storeid;

            searchCounter++;
            showStoresList(map.data, rankedStores, closestStoreId);

            const closest = rankedStores[0];
            if (!closest) return;

            const feature = map.data.getFeatureById(closest.storeid);
            const loc = feature.getGeometry().get("coordinates");

            map.setCenter(loc);
            map.setZoom(13);

            showStoreInformation({ feature });
        });
    });

    // ---------------- RESET ----------------

    document.getElementById("resetmap").addEventListener("click", () => {
        map.setCenter({ lat: 21.5449763, lng: -98.9680817 });
        map.setZoom(5.75);

        input.value = "";
        originMarker.setVisible(false);
        infoWindow.close();

        searchCounter = 0;

        const initialStores = getInitialStores(map.data);
        showStoresList(map.data, initialStores);
    });
}

// ---------------- HELPERS ----------------

function setUserMarker(coords, visible = true) {
    originMarker.setPosition(coords);
    originMarker.setVisible(visible);
    originMarker.setIcon({
        url: "https://cdn.shopify.com/s/files/1/1920/5567/files/pin-lightgreen.webp",
        scaledSize: new google.maps.Size(30, 30),
    });
}

function showStoreInformation(event) {
    const f = event.feature;

    const name = f.getProperty("name");
    const description = f.getProperty("description");
    const hours = f.getProperty("hours");
    const walink = f.getProperty("walink");
    const glink = f.getProperty("mapslink");
    const imgtienda = f.getProperty("imgtienda");

    const hoursHTML = hours
        ? `<p class="suc-hours"><b>Horario:</b> ${hours}</p>`
        : "";
    const glinkHTML = glink
        ? `
        <a href="${glink}" target="_blank" class="desc_link">
            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1" viewBox="0 0 512 512">
            <path d="M256,0C138.23.13,42.8,95.57,42.67,213.33c0,112.68,179.2,267.37,199.55,284.65l13.78,11.65,13.78-11.65c20.35-17.28,199.55-171.97,199.55-284.65C469.2,95.57,373.77.13,256,0ZM256,320c-58.91,0-106.67-47.76-106.67-106.67s47.76-106.67,106.67-106.67,106.67,47.76,106.67,106.67c-.07,58.88-47.79,106.6-106.67,106.67Z"/>
            </svg>
        </a>`
        : "";
    const walinkHTML = walink
        ? `<div class="card_linkdivider"></div>
            <a href="${walink}" target="_blank" class="desc_link">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve" width="512" height="512">
                <g id="WA_Logo">
	            <g>
		        <path style="fill-rule:evenodd;clip-rule:evenodd;" d="M20.463,3.488C18.217,1.24,15.231,0.001,12.05,0    C5.495,0,0.16,5.334,0.157,11.892c-0.001,2.096,0.547,4.142,1.588,5.946L0.057,24l6.304-1.654    c1.737,0.948,3.693,1.447,5.683,1.448h0.005c6.554,0,11.89-5.335,11.893-11.893C23.944,8.724,22.708,5.735,20.463,3.488z     M12.05,21.785h-0.004c-1.774,0-3.513-0.477-5.031-1.378l-0.361-0.214l-3.741,0.981l0.999-3.648l-0.235-0.374    c-0.99-1.574-1.512-3.393-1.511-5.26c0.002-5.45,4.437-9.884,9.889-9.884c2.64,0,5.122,1.03,6.988,2.898    c1.866,1.869,2.893,4.352,2.892,6.993C21.932,17.351,17.498,21.785,12.05,21.785z M17.472,14.382    c-0.297-0.149-1.758-0.868-2.031-0.967c-0.272-0.099-0.47-0.149-0.669,0.148s-0.767,0.967-0.941,1.166    c-0.173,0.198-0.347,0.223-0.644,0.074c-0.297-0.149-1.255-0.462-2.39-1.475c-0.883-0.788-1.48-1.761-1.653-2.059    s-0.018-0.458,0.13-0.606c0.134-0.133,0.297-0.347,0.446-0.521C9.87,9.97,9.919,9.846,10.019,9.647    c0.099-0.198,0.05-0.372-0.025-0.521C9.919,8.978,9.325,7.515,9.078,6.92c-0.241-0.58-0.486-0.501-0.669-0.51    C8.236,6.401,8.038,6.4,7.839,6.4c-0.198,0-0.52,0.074-0.792,0.372c-0.272,0.298-1.04,1.017-1.04,2.479    c0,1.463,1.065,2.876,1.213,3.074c0.148,0.198,2.095,3.2,5.076,4.487c0.709,0.306,1.263,0.489,1.694,0.626    c0.712,0.226,1.36,0.194,1.872,0.118c0.571-0.085,1.758-0.719,2.006-1.413c0.248-0.694,0.248-1.29,0.173-1.413    C17.967,14.605,17.769,14.531,17.472,14.382z"/>
	            </g>
                </g>
                </svg>
            </a>`
        : "";

    const content = `
    <div class="ult_mapmarker">
      <div class="carc-cont_mapmarker">
        <div class="suc-img_cont">
          <img src="${imgtienda}" class="suc-image">
        </div>
        <div class="localizador_card_cont">
          <p class="store-name">${name}</p>
          <p class="suc-description" style="text-align:center;">
            ${description}
          </p>
          ${hoursHTML}
          <div class="links-cont-map">
          ${glinkHTML}
          ${walinkHTML}
          </div>
        </div>
      </div>
    </div>
  `;

    const pos = f.getGeometry().get("coordinates");

    infoWindow.setContent(content);
    infoWindow.setPosition(pos);
    infoWindow.open(map);

    map.setCenter(pos);
    map.setZoom(13);
}

// ---------------- DISTANCE ----------------

async function calculateDistances(data, origin) {
    const stores = [];
    const destinations = [];

    data.forEach((store) => {
        stores.push(store.getProperty("storeid"));
        destinations.push(store.getGeometry().get());
    });

    const service = new google.maps.DistanceMatrixService();

    const distances = await new Promise((resolve, reject) => {
        service.getDistanceMatrix(
            {
                origins: [origin],
                destinations,
                travelMode: "DRIVING",
            },
            (res, status) => {
                if (status !== "OK") return reject(res);

                resolve(
                    res.rows[0].elements.map((el, i) => ({
                        storeid: stores[i],
                        distanceVal: el.distance.value,
                    }))
                );
            }
        );
    });

    return distances.sort((a, b) => a.distanceVal - b.distanceVal);
}

// ---------------- STORE LIST ----------------

function getInitialStores(data) {
    const stores = [];

    data.forEach((store) => {
        stores.push({
            storeid: store.getProperty("storeid"),
            distanceVal: 999999999, // keeps stable order
        });
    });

    return stores;
}

function showStoresList(data, stores, closestStoreId = null) {
    const panel = document.getElementById("storelistcont");

    stores.sort((a, b) => a.distanceVal - b.distanceVal);

    panel.innerHTML = "";

    if (searchCounter > 0) {
        const title = document.createElement("div");
        title.className = "results-title-cont";
        panel.appendChild(title);
    }

    stores.forEach((store) => {
        const isClosest =
            searchCounter > 0 && store.storeid == closestStoreId;

        const f = data.getFeatureById(store.storeid);

        const tiendaNueva = f.getProperty("nueva");

        const el = document.createElement("div");
        el.className = "store-info_cont";

        el.innerHTML = `
    ${isClosest ? `<div class="closest-badge">Más cercana</div>` : ""}
    ${tiendaNueva ? `<div class="closest-badge">Cerrado</div>` : ""}

    <a href="#map" class="card-link-map">
      <div class="description_cont" data-storeid="${store.storeid}">
        <p class="place">${f.getProperty("name")}</p>
        <p class="place-address">${f.getProperty("description")}</p>
      </div>
    </a>
  `;

        panel.appendChild(el);
    });
}
